// extracted by mini-css-extract-plugin
module.exports = {"businessFlex":"KYC_businessFlex__14tJp","save":"KYC_save__2Viuf","upperHeading":"KYC_upperHeading__1WWzo"};